import React from 'react';
import { useInjection } from '../../di/DependencyContext';
import DependencyType from '../../di/DependencyType';
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { AuthService, MFASecret } from '../../di/services/AuthService';
import PairingCodeInput from '../../components/pairing_code_input';

import styles from './authpages.module.css';

function QRCode(props: { size: number, value: string }) {
    return null;
}

const MFAOnboardPage = () => {
    const [mfaSecret, setMfaSecret] = React.useState<MFASecret>();
    const [didError, setDidError] = React.useState(false);
    const [authCode, setAuthCode] = React.useState('');
    const [requestId, setRequestId] = React.useState<string>();
    const [loading, setLoading] = React.useState(false);
    const authService = useInjection<AuthService>(DependencyType.AuthService);

    const handleSubmit = async () => {
        if (!requestId) {
            return;
        }

        setLoading(true);

        try {
            const auth = getAuth();
            await authService
                .verifyMFARequest(requestId, authCode)
                .then(token => {
                    if (token) {
                        void signInWithCustomToken(auth, token).then().catch();
                        setDidError(false);
                    } else {
                        console.log('Invalid');
                        setDidError(true);
                    }
                })
                .catch();
        } catch {
            setDidError(true);
        } finally {
            setLoading(false);
        }
    };

    React.useEffect(() => {
        void authService
            .generateMFASecret()
            .then(secret => {
                setMfaSecret(secret);
            })
            .catch();
    }, []);

    React.useEffect(() => {
        void authService
            .generateMFARequest()
            .then(requestId => setRequestId(requestId))
            .catch(() => {
                setDidError(true);
            });
    }, [mfaSecret]);

    if (!mfaSecret || !requestId) {
        return <>Loading</>;
    }

    return (
        <div className={styles.container}>
            <img src="/img/cloudshelf_long_logo.png" alt="Cloudshelf" style={{ width: 243 }} />
            <div className={styles.formContainer}>
                <h1 className={styles.h1}>Two Factor Authentication</h1>

                <h2>Please scan the QR code below to add to an authenticator app</h2>

                <div className={styles.qrContainer}>
                    <img src={mfaSecret.qr}/>
                </div>

                <label>Then, enter the 6-digit code displayed on your app:</label>
                <span className={`${styles.authInput} ${didError ? styles.errorInput : ''}`}>
                    <PairingCodeInput onChange={value => setAuthCode(value)} />
                </span>

                {didError && (
                    <p className={`${styles.hintText} ${styles.errorText}`}>Invalid token. Please try again.</p>
                )}

                <button
                    className={styles.button}
                    onClick={handleSubmit}
                    disabled={authCode.length !== 6 || !requestId || loading}
                >
                    {loading ? 'Please wait' : 'Login'}
                </button>

                <br />

                <p className={styles.hintText}>
                    Don't have an authenticator app? We suggest <a href="https://authy.com/">authy</a>.
                </p>
                <p className={styles.hintText}>
                    Want to set this up later?{' '}
                    <a
                        href="#"
                        onClick={async () => {
                            const auth = getAuth();
                            await auth.signOut();
                        }}
                    >
                        Log out
                    </a>
                </p>
            </div>
        </div>
    );
};

export default MFAOnboardPage;
